import { useContext } from 'react';

import { UsersContext } from '../contexts';
import { UsersContextProps } from '../contexts/types';

export function useUsers(): UsersContextProps {
    return useContext(UsersContext);
}
